import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full py-14 px-4 bg-cream text-navy" data-id="element-96">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-97">
        {/* Guarantee Badge */}
        <div className="w-40 h-40 rounded-full border-4 border-gold flex items-center justify-center mb-10 relative" data-id="element-98">
          <div className="absolute inset-2 border border-gold/30 rounded-full" data-id="element-99"></div>
          <div className="flex flex-col items-center justify-center" data-id="element-100">
            <span className="font-serif text-3xl font-bold text-navy leading-none mb-1" data-id="element-101">
              7-DAY
            </span>
            <span className="text-xs font-bold tracking-widest text-navy/80 uppercase" data-id="element-102">
              Money Back
            </span>
            <span className="text-sm font-bold tracking-widest text-gold uppercase mt-1" data-id="element-103">
              Guarantee
            </span>
          </div>
        </div>

        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold mb-8" data-id="element-104">
          Try It For 7 Days. Feel The Shift — Or Pay Nothing.
        </h2>

        <div className="space-y-6 text-lg text-navy/80 leading-relaxed mb-12" data-id="element-105">
          <p data-id="element-106">
            I am so confident that The Lucky Flush Protocol will create a
            noticeable shift in your energy, clarity, and the pattern of events
            in your life, that I'm offering a full 7-day money-back guarantee.
          </p>
          <p data-id="element-107">
            If you complete the protocol and feel no different — simply email us
            and receive a full refund. No questions asked. No hoops to jump
            through.
          </p>
          <p className="font-serif italic text-2xl text-navy font-medium" data-id="element-108">
            You have nothing to lose. And a cleared frequency to gain.
          </p>
        </div>

        <a href="https://pay.hotmart.com/Q105372393V?checkoutMode=10" onClick={() => {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'AddToCart');
        }
      }} className="inline-flex items-center justify-center px-10 py-5 bg-cta-red text-white font-bold text-xl rounded-full animate-heartbeat hover:bg-red-700 transition-colors duration-300 shadow-xl" data-id="element-109">
          Claim Your Copy — Risk Free → $6.37
        </a>
      </div>
    </section>;
}